


// import React, { useContext, useMemo, useState, useEffect } from 'react';
// import { PageTitle, Card, LoadingSkeleton } from '../components/common';
// import { AuthContext } from '../contexts/AuthContext';
// import { mockCourses, mockEnrollments, mockProjects } from '../mockData';
// import { UserMode, Task } from '../types';
// import { Link } from 'react-router-dom';
// import { ResponsiveContainer, PieChart, Pie, Cell, Legend, RadialBarChart, RadialBar, PolarAngleAxis, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip } from 'recharts';

// const useCountUp = (end: number, duration: number = 1000) => {
//     const [count, setCount] = useState(0);
//     useEffect(() => {
//         let start = 0;
//         const startTime = Date.now();
//         const animate = () => {
//             const now = Date.now();
//             const progress = Math.min((now - startTime) / duration, 1);
//             const current = Math.floor(progress * (end - start) + start);
//             setCount(current);
//             if (progress < 1) {
//                 requestAnimationFrame(animate);
//             }
//         };
//         requestAnimationFrame(animate);
//     }, [end, duration]);
//     return count;
// };

// const StatCard: React.FC<{ title: string; value: number; icon: React.ReactElement<{ className?: string }>; color: string }> = ({ title, value, icon, color }) => {
//     const count = useCountUp(value);
//     return (
//         <Card className={`p-4 flex items-center overflow-hidden relative ${color}`}>
//             <div className="p-3 rounded-full bg-white/20 text-white mr-4">{React.cloneElement(icon, { className: "w-8 h-8" })}</div>
//             <div>
//                 <p className="text-sm text-white/80">{title}</p>
//                 <p className="text-3xl font-bold text-white">{count}</p>
//             </div>
//              <div className="absolute -bottom-4 -right-4 text-white/10">
//                 {React.cloneElement(icon, { className: "w-24 h-24" })}
//             </div>
//         </Card>
//     );
// };

// // Online Dashboard Icons
// const BookOpenIcon = ({className = "w-6 h-6"}) => <svg xmlns="http://www.w3.org/2000/svg" className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"></path><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"></path></svg>;
// const PlayCircleIcon = ({className = "w-6 h-6"}) => <svg xmlns="http://www.w3.org/2000/svg" className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><polygon points="10 8 16 12 10 16 10 8"></polygon></svg>;
// const CheckCircleIcon = ({className = "w-6 h-6"}) => <svg xmlns="http://www.w3.org/2000/svg" className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg>;
// const AwardIcon = ({className = "w-6 h-6"}) => <svg xmlns="http://www.w3.org/2000/svg" className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="8" r="7"></circle><polyline points="8.21 13.89 7 23 12 17 17 23 15.79 13.88"></polyline></svg>;

// // Offline Dashboard Icons
// const ListTodoIcon = ({className = "w-6 h-6"}) => <svg xmlns="http://www.w3.org/2000/svg" className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="5" width="6" height="6" rx="1" /><path d="m3 17 2 2 4-4" /><path d="M13 6h8" /><path d="M13 12h8" /><path d="M13 18h8" /></svg>;
// const RefreshCwIcon = ({className = "w-6 h-6"}) => <svg xmlns="http://www.w3.org/2000/svg" className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8" /><path d="M21 3v5h-5" /><path d="M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16" /><path d="M3 21v-5h5" /></svg>;
// const CheckCheckIcon = ({className = "w-6 h-6"}) => <svg xmlns="http://www.w3.org/2000/svg" className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M18 6 7 17l-5-5" /><path d="m22 10-7.5 7.5L13 16" /></svg>;
// const ClipboardListIcon = ({className = "w-6 h-6"}) => <svg xmlns="http://www.w3.org/2000/svg" className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect width="8" height="4" x="8" y="2" rx="1" ry="1" /><path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" /><path d="M12 11h4" /><path d="M12 16h4" /><path d="M8 11h.01" /><path d="M8 16h.01" /></svg>;


// const RADIAL_CHART_COLORS = ['#dc2626', '#f59e0b', '#8b5cf6', '#22c55e'];
// const PIE_CHART_COLORS = ['#3b82f6', '#f97316', '#8b5cf6', '#16a34a'];
// const BAR_CHART_COLORS = ["#ef4444", "#f97316", "#3b82f6"];

// const OnlineDashboard = () => {
//     const auth = useContext(AuthContext);
//     const { enrolledCount, activeCount, completedCount, certificatesCount } = useMemo(() => {
//         const user = auth?.currentUser;
//         if (!user) return { enrolledCount: 0, activeCount: 0, completedCount: 0, certificatesCount: 0 };

//         const enrolled = mockCourses.filter(c => user.enrolledCourseIds.includes(c.id));
//         const userEnrollments = mockEnrollments.filter(e => e.userId === user.id);

//         const completed = enrolled.filter(course => {
//             const enrollment = userEnrollments.find(e => e.courseId === course.id);
//             const totalLessons = (course.sections || []).flatMap(s => s.lessons).length;
//             return enrollment && totalLessons > 0 && enrollment.completedLessonIds.length === totalLessons;
//         });

//         return {
//             enrolledCount: enrolled.length,
//             activeCount: enrolled.length - completed.length,
//             completedCount: completed.length,
//             certificatesCount: completed.length // Assuming one certificate per completed course
//         };
//     }, [auth?.currentUser]);

//     const overallCompletion = enrolledCount > 0 ? (completedCount / enrolledCount) * 100 : 0;
//     const radialChartData = [{ name: 'Completion', value: overallCompletion, fill: RADIAL_CHART_COLORS[0] }];

//     const statusData = [
//         { name: 'Active Courses', value: activeCount, fill: PIE_CHART_COLORS[0] },
//         { name: 'Completed Courses', value: completedCount, fill: PIE_CHART_COLORS[1] }
//     ];

//      const RADIAN = Math.PI / 180;
//     const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent, index }: any) => {
//         const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
//         const x = cx + radius * Math.cos(-midAngle * RADIAN);
//         const y = cy + radius * Math.sin(-midAngle * RADIAN);
//         const p = percent || 0; // handle case where percent is undefined

//         return (
//             <text x={x} y={y} fill="white" textAnchor={x > cx ? 'start' : 'end'} dominantBaseline="central">
//                 {`${(p * 100).toFixed(0)}%`}
//             </text>
//         );
//     };

//     return (
//         <div className="space-y-6">
//             <PageTitle title="Dashboard" subtitle={`Welcome back, ${auth?.currentUser?.firstName}!`} />
//             <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
//                 <StatCard title="Enrolled Courses" value={enrolledCount} icon={<BookOpenIcon />} color="bg-gradient-to-r from-blue-500 to-blue-400" />
//                 <StatCard title="Active Courses" value={activeCount} icon={<PlayCircleIcon />} color="bg-gradient-to-r from-green-500 to-green-400" />
//                 <StatCard title="Completed Courses" value={completedCount} icon={<CheckCircleIcon />} color="bg-gradient-to-r from-yellow-500 to-yellow-400" />
//                 <StatCard title="Certificates Earned" value={certificatesCount} icon={<AwardIcon />} color="bg-gradient-to-r from-red-500 to-red-400" />
//             </div>

//             <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
//                 <Card className="lg:col-span-2 p-4">
//                     <h3 className="font-bold text-lg mb-4 text-gray-800">Course Status</h3>
//                     <ResponsiveContainer width="100%" height={300}>
//                         <PieChart>
//                             <Pie
//                                 data={statusData}
//                                 dataKey="value"
//                                 nameKey="name"
//                                 cx="50%"
//                                 cy="50%"
//                                 outerRadius={120}
//                                 labelLine={false}
//                                 label={renderCustomizedLabel}
//                             >
//                                 {statusData.map((entry, index) => (
//                                     <Cell key={`cell-${index}`} fill={PIE_CHART_COLORS[index % PIE_CHART_COLORS.length]} />
//                                 ))}
//                             </Pie>
//                             <Tooltip />
//                             <Legend />
//                         </PieChart>
//                     </ResponsiveContainer>
//                 </Card>
//                 <Card className="p-4">
//                     <h3 className="font-bold text-lg mb-4 text-gray-800">Overall Completion</h3>
//                      <ResponsiveContainer width="100%" height={300}>
//                         <RadialBarChart 
//                             innerRadius="70%" 
//                             outerRadius="90%" 
//                             data={radialChartData} 
//                             startAngle={90} 
//                             endAngle={-270}
//                         >
//                             <PolarAngleAxis
//                                 type="number"
//                                 domain={[0, 100]}
//                                 angleAxisId={0}
//                                 tick={false}
//                             />
//                             <RadialBar
//                                 background
// // FIX: Changed from clockwise to clockWise, which is the correct prop name for recharts.
//                                 // clockWise
//                                 dataKey="value"
//                                 cornerRadius={10}
//                             />
//                              <text
//                                 x="50%"
//                                 y="50%"
//                                 textAnchor="middle"
//                                 dominantBaseline="middle"
//                                 className="text-4xl font-bold fill-current text-gray-800"
//                             >
//                                 {`${Math.round(overallCompletion)}%`}
//                             </text>
//                         </RadialBarChart>
//                     </ResponsiveContainer>
//                 </Card>
//             </div>
//         </div>
//     );
// };

// const OfflineDashboard = () => {
//     const allTasks = useMemo(() => mockProjects.flatMap(p => p.features.flatMap(f => f.tasks)), []);

//     const taskStats = useMemo(() => {
//         const total = allTasks.length;
//         const todo = allTasks.filter(t => t.status === 'To Do').length;
//         const inProgress = allTasks.filter(t => t.status === 'In Progress').length;
//         const completed = allTasks.filter(t => t.status === 'Done').length;
//         return { total, todo, inProgress, completed };
//     }, [allTasks]);

//     const statusData = [
//         { name: 'To Do', value: taskStats.todo },
//         { name: 'In Progress', value: taskStats.inProgress },
//         { name: 'In Review', value: allTasks.filter(t => t.status === 'In Review').length },
//         { name: 'Done', value: taskStats.completed },
//     ];

//     const priorityData = [
//         { name: 'High', count: allTasks.filter(t => t.priority === 'High').length },
//         { name: 'Medium', count: allTasks.filter(t => t.priority === 'Medium').length },
//         { name: 'Low', count: allTasks.filter(t => t.priority === 'Low').length },
//     ];

//     const RADIAN = Math.PI / 180;
//     const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, value, index }: any) => {
//         const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
//         const x = cx + radius * Math.cos(-midAngle * RADIAN);
//         const y = cy + radius * Math.sin(-midAngle * RADIAN);

//         return (
//             <text x={x} y={y} fill="white" textAnchor={x > cx ? 'start' : 'end'} dominantBaseline="central" className="font-bold text-sm">
//                 {value}
//             </text>
//         );
//     };

//     return (
//         <div className="space-y-6">
//             <PageTitle title="Dashboard" subtitle="Here’s a quick overview of your tasks." />
//             <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
//                 <StatCard title="Total Tasks" value={taskStats.total} icon={<ClipboardListIcon />} color="bg-gradient-to-r from-yellow-500 to-yellow-400" />
//                 <StatCard title="To Do" value={taskStats.todo} icon={<ListTodoIcon />} color="bg-gradient-to-r from-orange-500 to-orange-400" />
//                 <StatCard title="In Progress" value={taskStats.inProgress} icon={<RefreshCwIcon />} color="bg-gradient-to-r from-red-500 to-red-400" />
//                 <StatCard title="Completed" value={taskStats.completed} icon={<CheckCheckIcon />} color="bg-gradient-to-r from-green-500 to-green-400" />
//             </div>

//             <div className="grid grid-cols-1 lg:grid-cols-5 gap-6">
//                 <Card className="lg:col-span-2 p-4">
//                      <h3 className="font-bold text-lg mb-4 text-gray-800">Tasks by Status</h3>
//                      <ResponsiveContainer width="100%" height={300}>
//                          <PieChart>
//                             <Pie
//                                 data={statusData}
//                                 dataKey="value"
//                                 nameKey="name"
//                                 cx="50%"
//                                 cy="50%"
//                                 outerRadius={100}
//                                 label={renderCustomizedLabel}
//                                 labelLine={false}
//                             >
//                                 {statusData.map((entry, index) => (
//                                     <Cell key={`cell-${index}`} fill={PIE_CHART_COLORS[index % PIE_CHART_COLORS.length]} />
//                                 ))}
//                             </Pie>
//                             <Tooltip />
//                             <Legend />
//                         </PieChart>
//                      </ResponsiveContainer>
//                 </Card>
//                  <Card className="lg:col-span-3 p-4">
//                      <h3 className="font-bold text-lg mb-4 text-gray-800">Tasks by Priority</h3>
//                      <ResponsiveContainer width="100%" height={300}>
//                         <BarChart data={priorityData} margin={{ top: 5, right: 20, left: -10, bottom: 5 }}>
//                             <CartesianGrid strokeDasharray="3 3" />
//                             <XAxis dataKey="name" />
//                             <YAxis allowDecimals={false} />
//                             <Tooltip />
//                             <Bar dataKey="count" name="Tasks">
//                                  {priorityData.map((entry, index) => (
//                                     <Cell key={`cell-${index}`} fill={BAR_CHART_COLORS[index % BAR_CHART_COLORS.length]} />
//                                 ))}
//                             </Bar>
//                         </BarChart>
//                     </ResponsiveContainer>
//                 </Card>
//             </div>
//         </div>
//     );
// };

// const DashboardPage: React.FC = () => {
//     const auth = useContext(AuthContext);
//     const [isLoading, setIsLoading] = useState(true);

//     useEffect(() => {
//         const timer = setTimeout(() => setIsLoading(false), 300);
//         return () => clearTimeout(timer);
//     }, []);

//     if (isLoading || !auth?.currentUser) {
//         return (
//             <div>
//                 <LoadingSkeleton className="h-9 w-1/3 mb-4" />
//                 <LoadingSkeleton className="h-5 w-1/2 mb-8" />
//                 <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
//                     {[...Array(4)].map((_, i) => <LoadingSkeleton key={i} className="h-28 rounded-xl" />)}
//                 </div>
//                  <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mt-6">
//                     <LoadingSkeleton className="lg:col-span-2 h-80 rounded-xl" />
//                     <LoadingSkeleton className="h-80 rounded-xl" />
//                 </div>
//             </div>
//         );
//     }

//     return auth.currentUser.mode === 'online' ? <OnlineDashboard /> : <OfflineDashboard />;
// };

// export default DashboardPage;

import React, { useContext, useMemo, useState, useEffect } from 'react';
import { PageTitle, Card, LoadingSkeleton } from '../components/common';
import { AuthContext } from '../contexts/AuthContext';
import { mockCourses, mockEnrollments, mockProjects } from '../mockData';
import { UserMode, Task } from '../types';
import { ResponsiveContainer, PieChart, Pie, Cell, Legend, RadialBarChart, RadialBar, PolarAngleAxis, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, LineChart, Line } from 'recharts';
import { getTraineeDashboard, getProgramProgress } from '../services/api';

// Update interface for API response based on your actual response
interface StatusCounts {
    TOD123: number;
    INP123: number;
    INR123: number;
    DON123: number;
}

interface PriorityCounts {
    low: number;
    medium: number;
    high: number;
    critical: number;
}

interface TraineeDashboardResponse {
    statusCounts: StatusCounts;
    priorityCounts: PriorityCounts;
}

const useCountUp = (end: number, duration: number = 1000) => {
    const [count, setCount] = useState(0);
    useEffect(() => {
        let start = 0;
        const startTime = Date.now();
        const animate = () => {
            const now = Date.now();
            const progress = Math.min((now - startTime) / duration, 1);
            const current = Math.floor(progress * (end - start) + start);
            setCount(current);
            if (progress < 1) {
                requestAnimationFrame(animate);
            }
        };
        requestAnimationFrame(animate);
    }, [end, duration]);
    return count;
};

const StatCard: React.FC<{ title: string; value: number; icon: React.ReactElement<{ className?: string }>; color: string; trend?: { value: string; positive: boolean } }> = ({ title, value, icon, color, trend }) => {
    const count = useCountUp(value);
    
    // Extract base color from Tailwind class (e.g., 'blue' from 'from-blue-500')
    const colorMatch = color.match(/from-(\w+)-/);
    const baseColor = colorMatch ? colorMatch[1] : 'primary';
    
    return (
        <Card className="p-5 border-none shadow-sm hover:shadow-md transition-shadow duration-300 bg-white group">
            <div className="flex justify-between items-start">
                <div>
                    <p className="text-xs font-bold text-gray-500 uppercase tracking-wider mb-1">{title}</p>
                    <h3 className="text-3xl font-extrabold text-gray-900">{count}</h3>
                    {trend && (
                        <div className={`mt-2 flex items-center text-xs font-bold ${trend.positive ? 'text-green-600' : 'text-red-600'}`}>
                            <span className="mr-1">{trend.positive ? '↑' : '↓'}</span>
                            {trend.value}
                            <span className="ml-1 text-gray-400 font-normal">than last week</span>
                        </div>
                    )}
                </div>
                <div className={`p-3 rounded-2xl bg-${baseColor}-50 text-${baseColor}-600 transition-colors duration-300 group-hover:bg-${baseColor}-600 group-hover:text-white`}>
                    {React.cloneElement(icon, { className: "w-6 h-6" })}
                </div>
            </div>
            {/* Subtle bottom accent line */}
            <div className={`absolute bottom-0 left-0 right-0 h-1 bg-${baseColor}-500/20 group-hover:bg-${baseColor}-500 transition-colors duration-300`}></div>
        </Card>
    );
};

// Online Dashboard Icons
const BookOpenIcon = ({ className = "w-6 h-6" }) => <svg xmlns="http://www.w3.org/2000/svg" className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"></path><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"></path></svg>;
const PlayCircleIcon = ({ className = "w-6 h-6" }) => <svg xmlns="http://www.w3.org/2000/svg" className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><polygon points="10 8 16 12 10 16 10 8"></polygon></svg>;
const CheckCircleIcon = ({ className = "w-6 h-6" }) => <svg xmlns="http://www.w3.org/2000/svg" className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg>;
const AwardIcon = ({ className = "w-6 h-6" }) => <svg xmlns="http://www.w3.org/2000/svg" className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="8" r="7"></circle><polyline points="8.21 13.89 7 23 12 17 17 23 15.79 13.88"></polyline></svg>;

// Offline Dashboard Icons
const ListTodoIcon = ({ className = "w-6 h-6" }) => <svg xmlns="http://www.w3.org/2000/svg" className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="5" width="6" height="6" rx="1" /><path d="m3 17 2 2 4-4" /><path d="M13 6h8" /><path d="M13 12h8" /><path d="M13 18h8" /></svg>;
const RefreshCwIcon = ({ className = "w-6 h-6" }) => <svg xmlns="http://www.w3.org/2000/svg" className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8" /><path d="M21 3v5h-5" /><path d="M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16" /><path d="M3 21v-5h5" /></svg>;
const CheckCheckIcon = ({ className = "w-6 h-6" }) => <svg xmlns="http://www.w3.org/2000/svg" className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M18 6 7 17l-5-5" /><path d="m22 10-7.5 7.5L13 16" /></svg>;
const ClipboardListIcon = ({ className = "w-6 h-6" }) => <svg xmlns="http://www.w3.org/2000/svg" className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect width="8" height="4" x="8" y="2" rx="1" ry="1" /><path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" /><path d="M12 11h4" /><path d="M12 16h4" /><path d="M8 11h.01" /><path d="M8 16h.01" /></svg>;
const EyeIcon = ({ className = "w-6 h-6" }) => <svg xmlns="http://www.w3.org/2000/svg" className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z" /><circle cx="12" cy="12" r="3" /></svg>;


const RADIAL_CHART_COLORS = ['#dc2626', '#f59e0b', '#8b5cf6', '#22c55e'];
const PIE_CHART_COLORS = ['#3b82f6', '#f97316', '#8b5cf6', '#16a34a'];
const BAR_CHART_COLORS = ["#22c55e", "#f59e0b", "#ef4444"];

const OnlineDashboard = () => {
    const auth = useContext(AuthContext);
    const { enrolledCount, activeCount, completedCount, certificatesCount } = useMemo(() => {
        const user = auth?.currentUser;
        if (!user) return { enrolledCount: 0, activeCount: 0, completedCount: 0, certificatesCount: 0 };

        const enrolled = mockCourses.filter(c => user.enrolledCourseIds.includes(c.id));
        const userEnrollments = mockEnrollments.filter(e => e.userId === user.id);

        const completed = enrolled.filter(course => {
            const enrollment = userEnrollments.find(e => e.courseId === course.id);
            const totalLessons = (course.sections || []).flatMap(s => s.lessons).length;
            return enrollment && totalLessons > 0 && enrollment.completedLessonIds.length === totalLessons;
        });

        return {
            enrolledCount: enrolled.length,
            activeCount: enrolled.length - completed.length,
            completedCount: completed.length,
            certificatesCount: completed.length // Assuming one certificate per completed course
        };
    }, [auth?.currentUser]);

    const overallCompletion = enrolledCount > 0 ? (completedCount / enrolledCount) * 100 : 0;
    const radialChartData = [{ name: 'Completion', value: overallCompletion, fill: RADIAL_CHART_COLORS[0] }];

    const statusData = [
        { name: 'Active Courses', value: activeCount, fill: PIE_CHART_COLORS[0] },
        { name: 'Completed Courses', value: completedCount, fill: PIE_CHART_COLORS[1] }
    ];

    const RADIAN = Math.PI / 180;
    const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent, index }: any) => {
        const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
        const x = cx + radius * Math.cos(-midAngle * RADIAN);
        const y = cy + radius * Math.sin(-midAngle * RADIAN);
        const p = percent || 0; // handle case where percent is undefined

        return (
            <text x={x} y={y} fill="white" textAnchor={x > cx ? 'start' : 'end'} dominantBaseline="central">
                {`${(p * 100).toFixed(0)}%`}
            </text>
        );
    };

    return (
        <div className="space-y-8">
            <header className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
                <div>
                    <h1 className="text-2xl sm:text-3xl font-extrabold text-gray-900">Online Dashboard</h1>
                    <p className="text-gray-500 mt-1 font-medium">Welcome back, <span className="text-primary-600 font-bold">{auth?.currentUser?.firstName}</span>! Ready to continue your journey?</p>
                </div>
                <div className="flex items-center gap-3">
                    <span className="flex h-3 w-3 rounded-full bg-green-500 animate-pulse"></span>
                    <span className="text-sm font-bold text-gray-600">Online Access Active</span>
                </div>
            </header>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                <StatCard title="Enrolled Courses" value={enrolledCount} icon={<BookOpenIcon />} color="from-blue-500" trend={{ value: '12%', positive: true }} />
                <StatCard title="Active Courses" value={activeCount} icon={<PlayCircleIcon />} color="from-green-500" />
                <StatCard title="Completed Courses" value={completedCount} icon={<CheckCircleIcon />} color="from-amber-500" />
                <StatCard title="Certificates Earned" value={certificatesCount} icon={<AwardIcon />} color="from-red-500" />
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
                <Card className="lg:col-span-2 p-4">
                    <h3 className="font-bold text-lg mb-4 text-gray-800">Course Status</h3>
                    <ResponsiveContainer width="100%" height={300}>
                        <PieChart>
                            <Pie
                                data={statusData}
                                dataKey="value"
                                nameKey="name"
                                cx="50%"
                                cy="50%"
                                outerRadius={120}
                                labelLine={false}
                                label={renderCustomizedLabel}
                            >
                                {statusData.map((entry, index) => (
                                    <Cell key={`cell-${index}`} fill={PIE_CHART_COLORS[index % PIE_CHART_COLORS.length]} />
                                ))}
                            </Pie>
                            <Tooltip />
                            <Legend />
                        </PieChart>
                    </ResponsiveContainer>
                </Card>
                <Card className="p-4">
                    <h3 className="font-bold text-lg mb-4 text-gray-800">Overall Completion</h3>
                    <ResponsiveContainer width="100%" height={300}>
                        <RadialBarChart
                            innerRadius="70%"
                            outerRadius="90%"
                            data={radialChartData}
                            startAngle={90}
                            endAngle={-270}
                        >
                            <PolarAngleAxis
                                type="number"
                                domain={[0, 100]}
                                angleAxisId={0}
                                tick={false}
                            />
                            <RadialBar
                                background
                                dataKey="value"
                                cornerRadius={10}
                            />
                            <text
                                x="50%"
                                y="50%"
                                textAnchor="middle"
                                dominantBaseline="middle"
                                className="text-4xl font-bold fill-current text-gray-800"
                            >
                                {`${Math.round(overallCompletion)}%`}
                            </text>
                        </RadialBarChart>
                    </ResponsiveContainer>
                </Card>
            </div>
        </div>
    );
};

const OfflineDashboard = () => {
    const auth = useContext(AuthContext);
    const [dashboardData, setDashboardData] = useState<TraineeDashboardResponse | null>(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);
    const [programProgress, setProgramProgress] = useState<any[]>([]);
    const [programSummary, setProgramSummary] = useState<any>(null);

    // Fetch dashboard data from API
    useEffect(() => {
        const fetchDashboardData = async () => {
            // Get TraineeToken from localStorage
            const traineeToken = localStorage.getItem('TraineeToken');

            if (!traineeToken) {
                console.log('No TraineeToken found in localStorage');
                setError('Authentication token not found. Please login again.');
                setIsLoading(false);
                return;
            }

            try {
                setIsLoading(true);
                setError(null);
                console.log('Fetching trainee dashboard with token:', traineeToken);

                // Call the APIs with TraineeToken
                const [dashboardRes, progressRes] = await Promise.all([
                    getTraineeDashboard(traineeToken),
                    getProgramProgress(traineeToken).catch(err => {
                        console.error("Progress API failed, using fallback:", err);
                        return { success: false, data: [] };
                    })
                ]);

                console.log('Dashboard API response:', dashboardRes);
                console.log('Progress API response:', progressRes);

                setDashboardData(dashboardRes);
                if (progressRes.success) {
                    setProgramProgress(progressRes.data);
                    setProgramSummary(progressRes.summary);
                }
            } catch (err: any) {
                console.error("Error fetching dashboard data:", err);
                setError(err.response?.data?.message || "Failed to load dashboard data");
                // Fallback to mock data if API fails - using your API response structure
                const mockResponse: TraineeDashboardResponse = {
                    statusCounts: { TOD123: 2, INP123: 1, INR123: 3, DON123: 2 },
                    priorityCounts: { low: 0, medium: 4, high: 1, critical: 0 }
                };
                setDashboardData(mockResponse);
            } finally {
                setIsLoading(false);
            }
        };

        fetchDashboardData();
    }, []); // Empty dependency array since we're using localStorage

    // Calculate task stats from API response
    const taskStats = useMemo(() => {
        if (!dashboardData) {
            return { total: 0, todo: 0, inProgress: 0, inReview: 0, completed: 0 };
        }

        const { statusCounts } = dashboardData;

        const todo = statusCounts.TOD123 || 0;
        const inProgress = statusCounts.INP123 || 0;
        const inReview = statusCounts.INR123 || 0;
        const completed = statusCounts.DON123 || 0;

        const total = todo + inProgress + inReview + completed;

        return { total, todo, inProgress, inReview, completed };
    }, [dashboardData]);

    // Prepare chart data from API response
    const statusData = useMemo(() => {
        if (!dashboardData) return [];

        const { statusCounts } = dashboardData;

        return [
            { name: 'To Do', value: statusCounts.TOD123 || 0 },
            { name: 'In Progress', value: statusCounts.INP123 || 0 },
            { name: 'In Review', value: statusCounts.INR123 || 0 },
            { name: 'Completed', value: statusCounts.DON123 || 0 },
        ];
    }, [dashboardData]);

    const priorityData = useMemo(() => {
        if (!dashboardData) return [];

        const { priorityCounts } = dashboardData;

        return [
            { name: 'Low', count: priorityCounts.low || 0 },
            { name: 'Medium', count: priorityCounts.medium || 0 },
            { name: 'High', count: priorityCounts.high || 0 },
            // { name: 'Critical', count: priorityCounts.critical || 0 },
        ];
    }, [dashboardData]);

    const RADIAN = Math.PI / 180;
    const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, value, index }: any) => {
        const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
        const x = cx + radius * Math.cos(-midAngle * RADIAN);
        const y = cy + radius * Math.sin(-midAngle * RADIAN);

        return (
            <text x={x} y={y} fill="white" textAnchor={x > cx ? 'start' : 'end'} dominantBaseline="central" className="font-bold text-sm">
                {value}
            </text>
        );
    };

    // Weekly progress data for 12 weeks
    const weeklyData = useMemo(() => {
        // If we have real program progress from API, use it
        if (programProgress && programProgress.length > 0) {
            return programProgress;
        }

        // Fallback to simulated data if API is not yet available or empty
        const weeks = [];
        for (let i = 1; i <= 12; i++) {
            weeks.push({
                week: `Week ${i}`,
                completed: Math.floor(Math.random() * (taskStats.completed + 3)) + (i <= 4 ? 0 : 1),
            });
        }
        // Make last week match actual completed count
        if (weeks.length > 0) {
            weeks[weeks.length - 1].completed = taskStats.completed;
        }
        return weeks;
    }, [programProgress, taskStats.completed]);

    if (isLoading) {
        return (
            <div className="space-y-8">
                <header className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
                    <LoadingSkeleton className="h-10 w-64" />
                    <LoadingSkeleton className="h-10 w-44 rounded-2xl" />
                </header>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-6">
                    {[...Array(5)].map((_, i) => <LoadingSkeleton key={i} className="h-32 rounded-xl" />)}
                </div>
                <div className="grid grid-cols-1 lg:grid-cols-5 gap-6">
                    <LoadingSkeleton className="lg:col-span-2 h-96 rounded-xl" />
                    <LoadingSkeleton className="lg:col-span-3 h-96 rounded-xl" />
                </div>
            </div>
        );
    }

    if (error && !dashboardData) {
        return (
            <div className="space-y-6">
                <PageTitle title="Dashboard" subtitle="Here's a quick overview of your tasks." />
                <div className="bg-red-50 border border-red-200 rounded-lg p-4">
                    <p className="text-red-800">Error: {error}</p>
                    <button
                        onClick={() => window.location.reload()}
                        className="mt-2 px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700"
                    >
                        Retry
                    </button>
                </div>
            </div>
        );
    }

    return (
        <div className="space-y-8">
            <header className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
                <div>
                    <h1 className="text-2xl sm:text-3xl font-extrabold text-gray-900">Learning Dashboard</h1>
                    <p className="text-gray-500 mt-1 font-medium italic">Empower your skills through project-driven excellence.</p>
                </div>
                <div className="flex items-center gap-3 bg-white px-5 py-2.5 rounded-2xl shadow-sm border border-gray-100">
                    <span className="flex h-3.5 w-3.5 rounded-full bg-primary-600 shadow-[0_0_8px_rgba(var(--color-primary-600),0.4)]"></span>
                    <span className="text-xs font-extrabold text-gray-800 uppercase tracking-widest">
                        {auth?.currentUser?.mode === 'online' ? 'Online Student' : 'Offline Student'}
                    </span>
                </div>
            </header>

            {/* Updated grid to show all 5 cards in one line */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4 sm:gap-6">
                <StatCard title="TOTAL TASK" value={taskStats.total} icon={<ClipboardListIcon />} color="from-amber-500" trend={{ value: '8%', positive: true }} />
                <StatCard title="TO DO" value={taskStats.todo} icon={<ListTodoIcon />} color="from-orange-500" />
                <StatCard title="IN PROGRESS" value={taskStats.inProgress} icon={<RefreshCwIcon />} color="from-red-500" />
                <StatCard title="IN REVIEW" value={taskStats.inReview} icon={<EyeIcon />} color="from-blue-500" />
                <StatCard title="COMPLETED" value={taskStats.completed} icon={<CheckCheckIcon />} color="from-green-500" trend={{ value: '25%', positive: true }} />
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6">
                <Card className="md:col-span-1 lg:col-span-2 p-6">
                    <div className="border-b border-gray-100 pb-4 mb-6">
                        <h3 className="font-bold text-lg text-gray-800 tracking-tight">Tasks by Status</h3>
                        <p className="text-xs text-gray-400 font-medium">Distribution of tasks across your workflow</p>
                    </div>
                    <ResponsiveContainer width="100%" height={300}>
                        <PieChart>
                            <Pie
                                data={statusData}
                                dataKey="value"
                                nameKey="name"
                                cx="50%"
                                cy="50%"
                                innerRadius={60}
                                outerRadius={90}
                                label={renderCustomizedLabel}
                                labelLine={false}
                                paddingAngle={5}
                            >
                                {statusData.map((entry, index) => (
                                    <Cell key={`cell-${index}`} fill={PIE_CHART_COLORS[index % PIE_CHART_COLORS.length]} />
                                ))}
                            </Pie>
                            <Tooltip />
                            <Legend verticalAlign="bottom" height={36}/>
                        </PieChart>
                    </ResponsiveContainer>
                </Card>
                <Card className="md:col-span-1 lg:col-span-3 p-6">
                    <div className="border-b border-gray-100 pb-4 mb-6">
                        <h3 className="font-bold text-lg text-gray-800 tracking-tight">Tasks by Priority</h3>
                        <p className="text-xs text-gray-400 font-medium">Urgency distribution of your active project tasks</p>
                    </div>
                    <ResponsiveContainer width="100%" height={300}>
                        <BarChart data={priorityData} margin={{ top: 5, right: 30, left: 0, bottom: 5 }}>
                            <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#f3f4f6" />
                            <XAxis dataKey="name" />
                            <YAxis allowDecimals={false} />
                            <Tooltip />
                            <Bar dataKey="count" name="Tasks">
                                {priorityData.map((entry, index) => (
                                    <Cell key={`cell-${index}`} fill={BAR_CHART_COLORS[index % BAR_CHART_COLORS.length]} />
                                ))}
                            </Bar>
                        </BarChart>
                    </ResponsiveContainer>
                </Card>
            </div>

            {/* Progress Section: Graph + Speedometer */}
            <div className="grid grid-cols-1 lg:grid-cols-5 gap-6">
                {/* Weekly Progress Chart */}
                <Card className="lg:col-span-3 p-3 sm:p-5">
                    <div className="flex flex-col mb-6">
                        <h3 className="font-bold text-lg sm:text-xl text-gray-800">Overall Program Progress</h3>
                        {programSummary && (
                            <p className="text-sm text-gray-500 mt-1">
                                {programSummary.courseName} • {programSummary.batchName}
                            </p>
                        )}
                    </div>

                    <ResponsiveContainer width="100%" height={380}>
                        <LineChart
                            data={weeklyData}
                            margin={{ top: 10, right: 30, left: 0, bottom: 25 }}
                        >
                            <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" vertical={false} />
                            <XAxis
                                dataKey="week"
                                tick={{ fontSize: 11, fill: '#6b7280' }}
                                axisLine={{ stroke: '#e5e7eb' }}
                                tickLine={false}
                                label={{ value: 'Timeline', position: 'insideBottom', offset: -15, style: { fontWeight: '600', fontSize: 12, fill: '#4b5563' } }}
                            />
                            <YAxis
                                tick={{ fontSize: 11, fill: '#6b7280' }}
                                axisLine={false}
                                tickLine={false}
                                label={{ value: 'Progression', angle: -90, position: 'insideLeft', offset: 15, style: { fontWeight: '600', fontSize: 12, fill: '#4b5563' } }}
                            />
                            <Tooltip
                                content={({ active, payload, label }) => {
                                    if (active && payload && payload.length) {
                                        const data = payload[0].payload;
                                        return (
                                            <div className="bg-white p-3 border border-gray-200 shadow-xl rounded-lg">
                                                <p className="font-bold text-sm text-gray-800 mb-1">{label}</p>
                                                <div className="space-y-1">
                                                    <p className="text-xs text-gray-600">Module: <span className="font-semibold text-gray-800">{data.module}</span></p>
                                                    {data.completed !== null && (
                                                        <p className="text-xs text-gray-600">Status: <span className="text-green-600 font-bold">Touched</span></p>
                                                    )}
                                                </div>
                                            </div>
                                        );
                                    }
                                    return null;
                                }}
                            />
                            <Line
                                type="monotone"
                                dataKey={(v) => v.week.replace('Week ', '') / 4}
                                stroke="#e5e7eb"
                                strokeWidth={2}
                                strokeDasharray="5 5"
                                dot={false}
                                activeDot={false}
                            />
                            <Line
                                type="monotone"
                                dataKey="completed"
                                name="Progress"
                                stroke="#16a34a"
                                strokeWidth={4}
                                dot={{ r: 4, fill: '#16a34a', strokeWidth: 0 }}
                                activeDot={{ r: 6, fill: '#16a34a', stroke: '#fff', strokeWidth: 2 }}
                                animationDuration={1500}
                                connectNulls={false}
                            />
                        </LineChart>
                    </ResponsiveContainer>
                    <div className="flex items-center justify-center gap-6 mt-2">
                        <div className="flex items-center gap-2">
                            <div className="w-3 h-3 rounded-full bg-green-600"></div>
                            <span className="text-xs text-gray-500 font-medium">Actual</span>
                        </div>
                        <div className="flex items-center gap-2">
                            <div className="w-3 h-0.5 border-t-2 border-dashed border-gray-300"></div>
                            <span className="text-xs text-gray-500 font-medium">Target</span>
                        </div>
                    </div>
                </Card>

                {/* Speedometer for Days Left */}
                <Card className="lg:col-span-2 p-5 flex flex-col items-center justify-center relative overflow-hidden bg-white min-h-[550px]">
                    {programSummary?.daysRemaining === 0 ? (
                        <div className="flex flex-col items-center justify-center text-center animate-in fade-in zoom-in duration-700 w-full h-full relative">
                            {/* CSS Confetti Effect */}
                            <div className="absolute inset-0 pointer-events-none overflow-hidden">
                                {[...Array(20)].map((_, i) => (
                                    <div 
                                        key={i}
                                        className="absolute w-2 h-2 rounded-full animate-bounce"
                                        style={{
                                            left: `${Math.random() * 100}%`,
                                            top: `-10px`,
                                            backgroundColor: ['#3b82f6', '#10b981', '#f59e0b', '#ef4444', '#8b5cf6'][i % 5],
                                            animation: `confetti-fall ${2 + Math.random() * 3}s linear infinite`,
                                            animationDelay: `${Math.random() * 3}s`,
                                            opacity: 0.6
                                        }}
                                    />
                                ))}
                            </div>

                            <style dangerouslySetInnerHTML={{ __html: `
                                @keyframes confetti-fall {
                                    0% { transform: translateY(0) rotate(0deg); opacity: 1; }
                                    100% { transform: translateY(450px) rotate(720deg); opacity: 0; }
                                }
                            `}} />

                            <div className="mb-4 relative">
                                <div className="absolute -inset-4 bg-yellow-400/20 blur-2xl rounded-full animate-pulse"></div>
                                <img 
                                    src="/Graduation_Trophy.png" 
                                    alt="Graduation Trophy" 
                                    className="w-72 h-72 object-contain relative z-10 drop-shadow-2xl"
                                />
                            </div>
                            
                            <h3 className="text-3xl font-black text-gray-800 mb-2">Congratulations!</h3>
                            <p className="text-blue-600 font-bold text-lg mb-4">You have completed your program!</p>
                            
                            <div className="bg-yellow-50 border border-yellow-200 p-4 rounded-2xl w-full">
                                <p className="text-xs text-yellow-700 font-bold uppercase tracking-widest mb-1">Badge Earned</p>
                                <p className="text-sm font-medium text-yellow-800">Master of Excellence - {programSummary?.courseName}</p>
                            </div>
                        </div>
                    ) : (
                        <>
                            <div className="text-center w-full mb-2">
                                <h3 className="font-bold text-lg text-gray-800">Completion Countdown</h3>
                                <p className="text-xs text-gray-500">Days Remaining in Program</p>
                            </div>

                            <div className="relative w-full h-w-full flex items-center justify-center">
                                <ResponsiveContainer width="100%" height={280}>
                                    <PieChart>
                                        <Pie
                                            data={[
                                                { name: 'Elapsed', value: programSummary?.daysElapsed || 0 },
                                                { name: 'Remaining', value: programSummary?.daysRemaining || 1 }
                                            ]}
                                            cx="50%"
                                            cy="80%"
                                            startAngle={180}
                                            endAngle={0}
                                            innerRadius={80}
                                            outerRadius={120}
                                            paddingAngle={0}
                                            dataKey="value"
                                        >
                                            <Cell fill="#e5e7eb" />
                                            <Cell fill="#3b82f6" />
                                        </Pie>
                                        <Tooltip />
                                    </PieChart>
                                </ResponsiveContainer>
                                
                                <div className="absolute top-[60%] left-1/2 -translate-x-1/2 text-center">
                                    <span className="block text-4xl font-black text-blue-600">
                                        {programSummary?.daysRemaining || 0}
                                    </span>
                                    <span className="text-sm font-bold text-gray-500 uppercase tracking-widest">Days Left</span>
                                </div>
                            </div>

                            <div className="mt-4 grid grid-cols-2 gap-4 w-full">
                                <div className="bg-gray-50 p-3 rounded-xl border border-gray-100 text-center">
                                    <p className="text-[10px] text-gray-400 font-bold uppercase mb-1">Total Days</p>
                                    <p className="text-base font-bold text-gray-700">{programSummary?.totalDays || 0}</p>
                                </div>
                                <div className="bg-blue-50 p-3 rounded-xl border border-blue-100 text-center">
                                    <p className="text-[10px] text-blue-400 font-bold uppercase mb-1">Percentage</p>
                                    <p className="text-base font-bold text-blue-700">
                                        {programSummary?.totalDays ? Math.round((programSummary.daysElapsed / programSummary.totalDays) * 100) : 0}%
                                    </p>
                                </div>
                            </div>
                        </>
                    )}
                </Card>
            </div>
        </div>
    );
};

const DashboardPage: React.FC = () => {
    const auth = useContext(AuthContext);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const timer = setTimeout(() => setIsLoading(false), 300);
        return () => clearTimeout(timer);
    }, []);

    if (isLoading || !auth?.currentUser) {
        return (
            <div>
                <LoadingSkeleton className="h-9 w-1/3 mb-4" />
                <LoadingSkeleton className="h-5 w-1/2 mb-8" />
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-3 sm:gap-4 md:gap-6">
                    {[...Array(5)].map((_, i) => <LoadingSkeleton key={i} className="h-28 rounded-xl" />)}
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-5 md:gap-6 mt-4 sm:mt-6">
                    <LoadingSkeleton className="md:col-span-1 lg:col-span-2 h-80 rounded-xl" />
                    <LoadingSkeleton className="md:col-span-1 lg:col-span-1 h-80 rounded-xl" />
                </div>
            </div>
        );
    }

    return auth.currentUser.mode === 'online' ? <OnlineDashboard /> : <OfflineDashboard />;
};

export default DashboardPage;